import * as React from 'react';
import { SVGProps } from 'react';

const IconOilBarrelSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2a1 1 0 0 1 2 0h1a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2h5ZM4 5h8v3a1 1 0 1 1 0 2v3a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2v-3a1 1 0 1 1 0-2V5Zm2 5.985c0-.338.121-.848.435-1.519.303-.65.727-1.324 1.182-1.955.128-.177.257-.348.383-.511.126.163.255.334.383.511.455.631.879 1.306 1.182 1.955.314.67.435 1.18.435 1.52C10 12.16 9.135 13 8 13s-2-.84-2-2.015Z"
    />
  </svg>
);
export default IconOilBarrelSizeS;
